/**
 * Clershion · "Potrebbe interessarti" con prodotti casuali.
 * La sezione renderizza un gruppo piu' grande di prodotti della stessa
 * categoria (calzature o vestiti) nascosti via CSS di default; qui ne
 * scegliamo a caso solo alcuni (quanti dice data-clershion-show-count) e
 * li rendiamo visibili, cosi' non si vedono sempre gli stessi prodotti.
 */
(function () {
  function shuffle(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = array[i];
      array[i] = array[j];
      array[j] = tmp;
    }
    return array;
  }

  function init() {
    document.querySelectorAll('ul[data-clershion-random-pool]').forEach(function (ul) {
      if (ul.dataset.clershionRandomDone) return;
      ul.dataset.clershionRandomDone = 'true';

      var showCount = parseInt(ul.dataset.clershionShowCount, 10) || 4;
      var items = Array.prototype.slice.call(ul.children);
      if (items.length <= showCount) {
        items.forEach(function (li) {
          li.style.display = 'block';
        });
        return;
      }

      shuffle(items);
      items.forEach(function (li, index) {
        li.style.display = index < showCount ? 'block' : 'none';
        ul.appendChild(li);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
